var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 18,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 12C27 12 20.9955 16.1424 10 18H27V12Z",
    fill: "#F48120"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05339 6.9502H2V10.6404H3.05339C3.61027 10.6404 4.01284 10.5062 4.36844 10.2177C4.79114 9.86881 5.03939 9.34547 5.03939 8.80201C5.03268 7.70836 4.22083 6.9502 3.05339 6.9502ZM3.89878 9.72791C3.67066 9.9292 3.38215 10.0231 2.91249 10.0231H2.71791V7.58088H2.91249C3.37544 7.58088 3.65724 7.6614 3.89878 7.8761C4.14703 8.09751 4.29464 8.4397 4.29464 8.7953C4.29464 9.1509 4.14703 9.5065 3.89878 9.72791Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08608 6.9502H5.36816V10.6404H6.08608V6.9502Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84387 8.36586C7.41446 8.20483 7.28698 8.09748 7.28698 7.9029C7.28698 7.66807 7.5151 7.49363 7.82374 7.49363C8.03844 7.49363 8.2196 7.58085 8.40075 7.79555L8.77648 7.30576C8.46785 7.03738 8.09883 6.89648 7.68955 6.89648C7.03873 6.89648 6.53552 7.35273 6.53552 7.95658C6.53552 8.4665 6.77035 8.72817 7.4413 8.96971C7.7231 9.07035 7.864 9.13745 7.9378 9.1777C8.0787 9.27164 8.1525 9.40582 8.1525 9.56014C8.1525 9.86207 7.91767 10.0835 7.59562 10.0835C7.25343 10.0835 6.97835 9.90903 6.81061 9.59369L6.34766 10.0432C6.67642 10.533 7.07899 10.7477 7.62246 10.7477C8.36721 10.7477 8.89725 10.2512 8.89725 9.53331C8.91067 8.93616 8.66242 8.66778 7.84387 8.36586Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13232 8.80147C9.13232 9.8884 9.98443 10.7271 11.0781 10.7271C11.3867 10.7271 11.6551 10.6667 11.9771 10.5124V9.66699C11.6886 9.9555 11.4337 10.0696 11.1116 10.0696C10.387 10.0696 9.87037 9.54622 9.87037 8.79476C9.87037 8.08355 10.4004 7.52667 11.0781 7.52667C11.4203 7.52667 11.6819 7.64744 11.9771 7.94266V7.09726C11.6618 6.93623 11.4001 6.86914 11.0915 6.86914C10.0113 6.86914 9.13232 7.72795 9.13232 8.80147Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6934 9.4327L16.7071 6.9502H15.9221L17.4854 10.7343H17.8746L19.4647 6.9502H18.6864L17.6934 9.4327Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7935 10.6404H21.8331V10.0164H20.5114V9.02342H21.7862V8.39944H20.5114V7.58088H21.8331V6.9502H19.7935V10.6404Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6847 8.04397C24.6847 7.35289 24.2083 6.95703 23.3764 6.95703H22.3096V10.6472H23.0275V9.16445H23.1214L24.1144 10.6472H25.0001L23.8393 9.09064C24.3828 8.97658 24.6847 8.60756 24.6847 8.04397ZM23.2355 8.65453H23.0275V7.53405H23.2489C23.6984 7.53405 23.94 7.72191 23.94 8.08422C23.94 8.45324 23.6984 8.65453 23.2355 8.65453Z",
    fill: "#231F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1844 10.7745C15.2701 10.7745 16.1503 9.89437 16.1503 8.80865C16.1503 7.72293 15.2701 6.84277 14.1844 6.84277C13.0987 6.84277 12.2185 7.72293 12.2185 8.80865C12.2185 9.89437 13.0987 10.7745 14.1844 10.7745Z",
    fill: "#F48120"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 17,
    rx: 1.5,
    stroke: "black",
    strokeOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.40bbdaf383e0d8461785f629abe616c2.svg";
export { ForwardRef as ReactComponent };